import React from "react";
import CustomButton from "../CustomButton/custombutton";
import edit from "../../images/icons/edit.png";
import send from "../../images/icons/send.png";
import "../NotificationCard/NotificationCard.css";

const NotificationCard = (props) => {
  return (
    <div className="notification-card">
      <div className="Actions space_between">
        <h6 className="card-title">{props.title}</h6>
        <p className="card-date">{props.date}</p>
      </div>
      <p className="card-text">{props.description}</p>
      <div className="Actions justify-content-between w-100">
        <CustomButton
          text={props.memberType}
          from="Noti"
          addIcon={false}
          className="disabled"
        />
        <div className="Actions">
          <CustomButton
            text="Edit"
            icon={edit}
            onClick={props.onClick}
            className="btnEdit cursor-pointer"
            addIcon={true}
          />
          <CustomButton
            text="Send"
            onClick={props.onSendNoti}
            icon={send}
            className="btnSend"
            addIcon={true}
          />
        </div>
      </div>
    </div>
  );
};

export default NotificationCard;
